var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.splitHeading[0]))]),_c('span',{class:_vm.colorString},[_vm._v(_vm._s(_vm.splitHeading[1]))]),_c('span',[_vm._v(_vm._s(_vm.splitHeading[2]))])])}
var staticRenderFns = []

export { render, staticRenderFns }